import { Link } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import Tooltip from "../../ToolTip";
import React from "react";

const SearchStockHolders = () => {
  return (
    <Tooltip content="جستجوی سهامدار">
      <Link aria-label="جستجوی سهامدار" to="/Sahamdaran" className="transform scale-125">
        <div className="py-2">
          <FiSearch />
        </div>
      </Link>
    </Tooltip>
  );
};

export default SearchStockHolders;